import React from 'react';
import { randomId } from '@aha-app/mvc';
import type { WhiteboardController } from '@aha-app/whiteboard';
import type { RecordId } from 'javascripts/shared-types';
import type AssistantViewController from 'components/Assistant/components/AssistantView/AssistantViewController';
import { type ScopeItem } from 'components/Assistant/components/AssistantView/AssistantViewController';
import { SelectionScopeItem } from 'components/Assistant/components/PromptPanel/ScopeItems';

class AssistedWhiteboard {
  selectionScopeItem: ScopeItem;

  constructor(private readonly whiteboardController: WhiteboardController) {}

  getSelection() {
    return this.whiteboardController.getWhiteboardSelectionForAssistant();
  }

  // Called multiple times - every time a chat is instantiated
  attachToAssistantViewController(
    assistantViewController: AssistantViewController
  ): void {
    // Set up scope item for this chat - this links the selection to the active
    // chat session in the assistant side panel
    const proxiedSelectionScopeItem = assistantViewController.setScopeItem(
      'selection',
      {
        id: randomId() as RecordId,
        resolve: () => this.getSelection(),
        render: null,
      }
    );
    this.selectionScopeItem = proxiedSelectionScopeItem;
  }

  registerSelectionChangeListener() {
    this.whiteboardController.registerCanvasSelectionChangeListener(objects => {
      if (!this.selectionScopeItem) return;

      if (objects.length === 0) {
        this.selectionScopeItem.render = null;
        return;
      }

      this.selectionScopeItem.render = () => {
        return (
          <SelectionScopeItem
            content={`${objects.length} ${
              objects.length === 1 ? 'item' : 'items'
            } selected`}
          />
        );
      };
    });
  }
}

export default AssistedWhiteboard;
